<template>
  <Table :columns="tableTitle" :data="tableData" border stripe height="600">
  </Table>
</template>
<script>
import { getPackList, readPackBox } from "@/api/double/list";

import boxMes from "@/utils/message";

export default {
  props: {
    billId: {
      type: String,
    },
  },
  data() {
    return {
      tableData: [],
      loading: true,
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("order_number"),
        key: "airway_bill_number",
        align: "center",
      });
      columns.push({
        title: this.$t("createTime"),
        key: "create_time",
        align: "center",
      });
      columns.push({
        title: this.$t("download") + this.$t("address"),
        align: "center",
        render(h, { row }) {
          return h(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
              },
              on: {
                click() {
                  readPackBox(row.id);
                  window.open(row.down_url, "_blank");
                },
              },
            },
            this.$t("download")
          );
        },
      });
      columns.push({
        title: this.$t("preview") + this.$t("address"),
        align: "center",
        render(h, { row }) {
          return h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              on: {
                click() {
                  readPackBox(row.id);
                  window.open(row.preview_url, "_blank");
                },
              },
            },
            this.$t("preview")
          );
        },
      });
      return columns;
    },
  },
  mounted() {
    this.getList(this.billId);
  },
  methods: {
    getList(id) {
      this.loading = true;
      getPackList({ id })
        .then((res) => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.tableData = res.data.payload;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.bill-form .ivu-form-item {
  margin-bottom: 10px;
}
</style>
